import { Component } from '@angular/core';

@Component({
  selector: 'num-section-name',
  templateUrl: './section-name.component.html',
  styleUrls: ['./section-name.component.scss'],
})
export class SectionNameComponent {}
